import React, { useState } from 'react';
import { ArrowUpRight, BriefcaseBusiness, MessageCircle } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from './components/ui/button';
import { Input } from './components/ui/input';

const STARTERS = [
  ['find me a job', 'find me an assignment'],
  ['is this pay fair?', 'is this pay fair?'],
  ['licensing help', 'I have a licensing question'],
  ['compare opportunities', 'help me compare jobs'],
];

export default function HomePage() {
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const beginConversation = (text = message) => {
    const trimmed = text.trim();
    navigate(trimmed ? `/concierge?message=${encodeURIComponent(trimmed)}` : '/concierge');
  };

  return (
    <main className="min-h-screen min-h-[100dvh] ht-ambient-bg ht-noise flex items-center justify-center">
      <div className="w-full max-w-3xl px-4 py-8 sm:px-6">
        <div className="flex flex-col items-center text-center space-y-5 sm:space-y-6">
          <span className="rounded-full bg-[#F0EFEA] px-3 py-1.5 text-xs lowercase text-[#6B6A68]">
            a calmer way to find your next assignment
          </span>
          <h1 className="font-serif text-5xl lowercase tracking-[-0.01em] text-[#3B3A39] sm:text-7xl" style={{ fontFamily: "'DM Serif Display', ui-serif, Georgia, serif" }}>
            hey, traveler.
          </h1>
          <div className="max-w-2xl space-y-2.5">
            <p className="text-lg leading-relaxed text-[#3B3A39] sm:text-2xl">A less noisy way to find your next assignment.</p>
            <p className="text-base text-[#6B6A68] sm:text-lg">Tell Alex what matters. We&apos;ll only show Care Team opportunities that HeyTraveler has reviewed and approved.</p>
          </div>

          <div className="flex flex-col items-stretch gap-2.5 sm:flex-row sm:items-center">
            <Button asChild className="h-14 rounded-xl bg-[#3B3A39] px-7 text-lg font-semibold text-white hover:bg-[#2C2B2A]">
              <Link to="/concierge"><MessageCircle className="mr-2.5 h-5 w-5" />Talk to Alex</Link>
            </Button>
            <Button asChild variant="outline" className="h-14 rounded-xl border-[#D8D6CF] bg-white/80 px-7 text-base font-semibold text-[#3B3A39] shadow-none hover:bg-white">
              <Link to="/jobs"><BriefcaseBusiness className="mr-2.5 h-5 w-5" />Browse Care Team jobs</Link>
            </Button>
          </div>

          <div className="flex w-full max-w-sm items-center gap-3">
            <div className="h-px flex-1 bg-[#E6E6E6]" /><span className="text-xs uppercase tracking-wider text-[#A8A7A5]">or chat here</span><div className="h-px flex-1 bg-[#E6E6E6]" />
          </div>

          <form onSubmit={(event) => { event.preventDefault(); beginConversation(); }} className="w-full max-w-2xl rounded-2xl border-2 border-[#E6E6E6] bg-white p-3 shadow-[0_20px_60px_-15px_rgba(0,0,0,0.12)] transition-shadow duration-500 hover:shadow-[0_20px_70px_-12px_rgba(0,0,0,0.18)] sm:p-4">
            <div className="flex items-center gap-2 sm:gap-3">
              <Input
                type="text"
                aria-label="Tell Alex what you are looking for"
                placeholder="ICU in Texas, locum ER in Florida..."
                value={message}
                onChange={(event) => setMessage(event.target.value)}
                className="h-11 flex-1 border-none bg-transparent px-2 text-base text-[#3B3A39] placeholder:text-[#A8A7A5] focus-visible:ring-0 focus-visible:ring-offset-0"
                style={{ fontSize: '16px' }}
              />
              <Button type="submit" aria-label="Start chat" className="h-11 w-11 shrink-0 rounded-full bg-[#3B3A39] p-0 text-white hover:bg-[#2C2B2A]">
                <ArrowUpRight className="h-4 w-4" />
              </Button>
            </div>
          </form>

          <div className="flex max-w-lg flex-wrap justify-center gap-2 pt-1">
            {STARTERS.map(([label, prompt]) => (
              <button key={label} type="button" onClick={() => beginConversation(prompt)} className="cursor-pointer rounded-full bg-[#F0EFEA] px-3 py-1.5 text-xs text-[#6B6A68] transition-all hover:bg-[#E6E6E2] active:scale-95">
                {label}
              </button>
            ))}
          </div>

          <p className="max-w-xl pt-2 text-center text-xs leading-relaxed text-[#A8A7A5]">
            HeyTraveler currently searches approved Care Team Solutions opportunities, supplied through Staffing Referrals. We&apos;re not searching every agency yet. <Link to="/privacy" className="underline hover:text-[#6B6A68]">Privacy Policy</Link>
          </p>
        </div>
      </div>
    </main>
  );
}
